'use strict';

const $ = window.jQuery;

export default class NavMobile {
    constructor() {
        $('.nav-main-mobile-l1__link').on('click', function (e) {
            e.stopPropagation();

            if ($(this).hasClass('has-children')) {
                e.preventDefault();

                $('.header-account-deployer, .header-account-menu, .header-search-deployer, .header-search-input, .lang-selector-deployer, .lang-selector-list').removeClass('is-active');
                $(this).next().toggleClass('is-active');

                setTimeout(() => {
                    $('.mega-menu__list__link, .mega-menu__right').removeClass('is-active');
                }, 200);
            }
        });

        $('.mega-menu__back').on('click', function (e) {
            e.stopPropagation();
            $('.mega-menu').removeClass('is-active');
        });

        $('.mega-menu__right__back').on('click', function (e) {
            e.stopPropagation();
            $('.mega-menu__list__link, .mega-menu__right').removeClass('is-active');
        });

        $('#openNavMobile').on('click', function () {
            $('.nav-mobile').addClass('nav-mobile--opened');
        });

        $('#closeNavMobile').on('click', function () {
            $('.nav-mobile').removeClass('nav-mobile--opened');
        });
    }
}
